var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(-18 46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(17.999 -46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9416",
    "data-name": "Group 9416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,0H24V24H0Z",
    transform: "translate(0.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9412",
    "data-name": "Group 9412",
    transform: "translate(3.001 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26734",
    d: "M0,1.4H4.049V0H8.276V1.4h4.079V9.539h-1.37V2.812h-2.7V4.2H4.057V2.808H1.415V16.582H9.53v1.41H0ZM6.867,2.78V1.421H5.5V2.78Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26735",
    d: "M111.03,104.04v7h-7v-7Zm-4.22,1.377c-.394,0-.762.013-1.129,0-.22-.011-.283.06-.281.28.01,1.223.005,2.447.005,3.67v.258h4.2v-4.188h-1.378V106.8H106.81Z",
    transform: "translate(-93.033 -93.042)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26736",
    d: "M57.257,118.51v1.4h-3.9v-1.4Z",
    transform: "translate(-47.719 -105.983)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26737",
    d: "M53.37,65.31h3.894v1.364H53.37Z",
    transform: "translate(-47.728 -58.406)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26738",
    d: "M57.248,92.05v1.359h-3.9V92.05Z",
    transform: "translate(-47.71 -82.32)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26739",
    d: "M26.54,118.49h1.391v1.392H26.54Z",
    transform: "translate(-23.735 -105.965)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26740",
    d: "M27.946,65.4v1.351h-1.4V65.4Z",
    transform: "translate(-23.743 -58.487)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26741",
    d: "M27.948,93.433H26.56V92.07h1.388Z",
    transform: "translate(-23.752 -82.338)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.1f7a2db121639045535af209863a6557.svg";
export { ForwardRef as ReactComponent };